import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { publicApi } from '@/lib/api';
import { useLanguage } from '@/lib/i18n';

export default function Cgv() {
  const [settings, setSettings] = useState({});
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    publicApi.getSettings()
      .then(r => {
        setSettings(r.data || {});
        setSettingsLoaded(true);
       })
      .catch(() => {
        setSettingsLoaded(true);
      });
  }, []);

  if (settingsLoaded && settings.ordersModuleEnabled !== true) {
    return <Navigate to="/" replace />;
  }

  const mediatorName = settings.mediator_name || 'AME Conso';
  const mediatorUrl = settings.mediator_url || 'https://www.mediationconso-ame.com';
  const mediatorAddress = settings.mediator_address || '11 Place Dauphine, 75001 Paris';

  return (
    <div className="min-h-screen bg-cream" data-testid="cgv-page">
      <Navbar />
      <div className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-heading font-bold text-garden-800 mb-8">{t('cgv.title')}</h1>

          <div className="bg-white rounded-2xl p-8 border border-garden-800/5 shadow-sm space-y-8 text-charcoal/80">
            <p className="text-sm leading-relaxed font-medium">
              {t('cgv.intro')}
            </p>

            <section className="space-y-3">
              <h2 className="text-xl font-heading font-semibold text-garden-800">{t('cgv.article1Title')}</h2>
              <p className="text-sm leading-relaxed">{t('cgv.article1Text')}</p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-heading font-semibold text-garden-800">{t('cgv.article2Title')}</h2>
              <p className="text-sm leading-relaxed">{t('cgv.article2Text')}</p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-heading font-semibold text-garden-800">{t('cgv.article3Title')}</h2>
              <p className="text-sm leading-relaxed bg-amber-50/50 p-4 rounded-xl border border-amber-500/10 text-charcoal/90">
                {t('cgv.article3Text')}
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-heading font-semibold text-garden-800">{t('cgv.article4Title')}</h2>
              <p className="text-sm leading-relaxed">{t('cgv.article4Text')}</p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-heading font-semibold text-garden-800">{t('cgv.article5Title')}</h2>
              <p className="text-sm leading-relaxed">
                {t('cgv.article5Text')}
              </p>
              <div className="text-xs bg-garden-50/50 p-4 rounded-xl border border-garden-850/5 mt-2 space-y-1">
                <p><strong>Nom :</strong> {mediatorName}</p>
                <p><strong>Adresse postale :</strong> {mediatorAddress}</p>
                <p><strong>Site internet :</strong> <a href={mediatorUrl} target="_blank" rel="noopener noreferrer" className="text-garden-800 underline hover:text-garden-900">{mediatorUrl}</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
